import { Redirect, Switch } from "react-router-dom";
import { RouteWithSubRoutes } from "./index";
import { checkPrivilege } from "./../utils";

const CheckRouter = (props: any) => {
  const { location, routers } = props;
  const { pathname } = location;

  const isHasToken = sessionStorage.getItem("accessToken") && sessionStorage.getItem("userInfo") && sessionStorage.getItem("functionPrivilege");
  return (
    <Switch>
      {
        routers.map((route: any) => {
          const targetRouterConfig = route?.children?.find((v: any) => v.path === pathname) || route;
          if (!targetRouterConfig.meta || !targetRouterConfig.meta.privilegeCode) {
            return <RouteWithSubRoutes key={route.path} {...route} />
          } else if (checkPrivilege(targetRouterConfig?.meta?.privilegeCode)) {
            return <RouteWithSubRoutes key={route.path} {...route} />
          } else if (!isHasToken) {
            return <Redirect key={route.path} exact to="/login" />
          } else {
            return <Redirect key={route.path} exact to="/noPrivilege" />
          }
        })
      }
    </Switch>
  );
}
export default CheckRouter;